import { IAppState } from '../common/state';

/**
 * Общая пустая ссылка: react-redux 9 сравнивает результат селектора по ссылке,
 * новый [] на каждый вызов приводит к лишним ререндерам на каждый экшен.
 */
const EMPTY_ITEMS: NonNullable<IAppState['results']['markedList']>['items'] = [];

export function selectMarkedListItems(state: IAppState) {
  return state.results.markedList?.items || EMPTY_ITEMS;
}
